var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0138 1V5C10.0138 5.26522 10.1192 5.51957 10.3067 5.70711C10.4942 5.89464 10.7486 6 11.0138 6H15.0138",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0138 10V17C15.0611 17.3774 14.9863 17.76 14.8003 18.0918C14.6143 18.4235 14.3269 18.687 13.9802 18.8435C13.6336 19.0001 13.2459 19.0415 12.8741 18.9617C12.5022 18.8818 12.1657 18.685 11.9138 18.4C11.7595 18.2026 11.5622 18.0429 11.337 17.933C11.1117 17.8232 10.8644 17.7661 10.6138 17.7661C10.3632 17.7661 10.1159 17.8232 9.89066 17.933C9.66541 18.0429 9.46814 18.2026 9.31381 18.4C9.15949 18.5974 8.96221 18.7571 8.73696 18.867C8.51172 18.9768 8.26441 19.0339 8.01381 19.0339C7.76321 19.0339 7.51591 18.9768 7.29066 18.867C7.06541 18.7571 6.86814 18.5974 6.71381 18.4C6.55948 18.2026 6.36221 18.0429 6.13696 17.933C5.91172 17.8232 5.66441 17.7661 5.41381 17.7661C5.16321 17.7661 4.91591 17.8232 4.69066 17.933C4.46541 18.0429 4.26814 18.2026 4.11381 18.4C3.86195 18.685 3.52542 18.8818 3.15355 18.9617C2.78167 19.0415 2.39401 19.0001 2.04738 18.8435C1.70074 18.687 1.41337 18.4235 1.22737 18.0918C1.04137 17.76 0.966527 17.3774 1.01381 17V3C1.01381 2.46957 1.22452 1.96086 1.5996 1.58579C1.97467 1.21071 2.48338 1 3.01381 1H10.0138L15.0138 6V10.25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.2aaf9d066d897288998686e825f9adcd.svg";
export { ForwardRef as ReactComponent };